import { inject, Injectable } from '@angular/core';
import { UseCase } from '@shared/helper';
import { PoinListDto, PoinListResp } from './poin.type';
import { PromoRepository } from '../../repositories/promo.repository';
import { catchError, Observable, throwError } from 'rxjs';
import { ErrorMessageService } from '@shared/services/error-message/error-message.service';

@Injectable({
    providedIn: 'root'
})

export class GetPoinListUseCase implements UseCase<PoinListDto, PoinListResp> {
    private readonly promoRepository = inject(PromoRepository);
    private readonly errorMessageService = inject(ErrorMessageService); 

    execute(payload: PoinListDto): Observable<PoinListResp> {
        return this.promoRepository.GetPoinList(payload).pipe(
            catchError((error) => {
                const {status_code, msisdn} = error;
                return throwError(()=> this.errorMessageService.getErrorMessage(status_code, msisdn));
            })
        );
    }
}